// extracted by mini-css-extract-plugin
export default {"feedback":"templates-change-email-module__feedback"};